import React from 'react';
import { UseGetHallOfFameQueryReturn } from '../hook/api/useGetHallOfFame';
import Loader from '../../commons/_/loader/Loader';
import { MarathonTile } from './component/type/Marathon';
import { StreakTile } from './component/type/Streak';
import { ChampionTile } from './component/type/Champion';

export type HallOfFameProps = {
	tab: string;
	query: UseGetHallOfFameQueryReturn;
};

export const HallOfFame = ({ tab, query }: HallOfFameProps) => {
	return (
		<>
			{query.isFetching ? (
				<div className="d-flex justify--center w-100 mt-4">
					<Loader fixed={false} />
				</div>
			) : (
				<div className="battles-hof row mt-4">
					{!!query.data && (
						<>
							<StreakTile data={query.data} />
							<ChampionTile data={query.data} />
							<MarathonTile data={query.data} />
						</>
					)}
				</div>
			)}
		</>
	);
};

export default HallOfFame;
